import { render } from "./ToggleSidebarButton.vue?vue&type=template&id=56a8ecba&scoped=true"
import script from "./ToggleSidebarButton.vue?vue&type=script&lang=js"
export * from "./ToggleSidebarButton.vue?vue&type=script&lang=js"

import "./ToggleSidebarButton.vue?vue&type=style&index=0&id=56a8ecba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a8ecba"]])

export default __exports__